import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { formConstant } from '../../../../../../config';
import { onConfirmDialog } from '../../../../../core/helpers/helpers.function';
import { NotificationService } from '../../../../../core/services/notification.service';
import { ConfirmPopupDialog } from '../../../../../shared/popups/confirm-popup/confirm-popup.component';
import { ICarriersItem } from '../../../models/carrier.interface';
import { CarrierNameService } from '../../../services/carrier-name.service';

export interface ICarrierNameItem {
    id: number;
    name: string;
    carrierId: number;
}

@Component({
    selector: 'eci-carrier-name-popup',
    templateUrl: './carrier-name-popup.component.html',
    styleUrls: ['./carrier-name-popup.component.scss']
})
export class CarrierNamePopupComponent implements OnInit {

    public title = 'Manage Carrier Names';
    public form: FormGroup;
    public showLoader: boolean = false;
    public nameMaxLength = formConstant.textFieldMaxLength120;
    public names: ICarrierNameItem[] = [];

    public carrier: ICarriersItem;

    private errorHandler = (err) => {
        this.notify.showError(err?.error?.message || 'Something went wrong');
        this.showLoader = false;
    }

    constructor(
        public dialogRef: MatDialogRef<CarrierNamePopupComponent>,
        private carrierNameService: CarrierNameService,
        private notify: NotificationService,
        private dialog: MatDialog
    ) {
    }

    ngOnInit(): void {
        this.form = this.initializeForm();
        this.loadNames();
    }

    private initializeForm(): FormGroup {
        return new FormGroup({
            name: new FormControl('', [
                Validators.required,
                Validators.maxLength(this.nameMaxLength),
            ]),
        });
    }

    public loadNames(): void {
        if (!this.carrier?.id) {
            return;
        }
        this.carrierNameService.getByCarrierId(this.carrier.id).subscribe((data) => {
            this.names = Array.isArray(data) ? data : (data ? [data] : []);
        }, this.errorHandler);
    }

    public onNoClick(): void {
        this.dialogRef.close();
    }

    public onAdd(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            this.notify.showError('Not all fields are filled');
            return;
        }
        this.showLoader = true;
        this.carrierNameService.create(this.carrier.id, this.form.get('name').value).subscribe(() => {
            this.notify.showSuccessMessage('Carrier name added successfully');
            this.form.reset();
            this.showLoader = false;
            this.loadNames();
        }, this.errorHandler);
    }

    public onDelete(item: ICarrierNameItem): void {
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        onConfirmDialog(dialogRef, () => {
            this.showLoader = true;
            this.carrierNameService.delete(item.id).subscribe(() => {
                this.notify.showSuccessMessage('Carrier name deleted successfully');
                this.showLoader = false;
                this.loadNames();
            }, this.errorHandler);
        }, 'this name');
    }

    public onDone(): void {
        this.dialogRef.close(true);
    }
}
